class SizeChart extends HTMLElement {
  constructor() {
    super()
    this.tabs = this.querySelectorAll('.size-chart-tab')
    this.contents = this.querySelectorAll('.size-chart-content')
    this.spinner = this.querySelector('.Page-Size-Chart__Loading')
    this.handleTabClick = this.handleTabClick.bind(this)
    this.initTabs()
  }

  initTabs() {
    if (this.tabs.length > 0) {
      this.loadTabContent(this.tabs[0].dataset.table, this.contents[0])
      this.hideSpinner()
      this.tabs.forEach(tab => {
        tab.addEventListener('click', this.handleTabClick)
      })
    }
  }

  async handleTabClick(event) {
    const tab = event.currentTarget
    const content = this.querySelector(`.size-chart-content[data-id="${tab.dataset.id}"]`)

    if (content.dataset.loaded) {
      this.setActiveTab(tab, content)
      return
    }

    this.showSpinner()

    this.contents.forEach(c => {
      c.innerHTML = ''
      c.removeAttribute('data-loaded')
    })

    await this.loadTabContent(tab.dataset.table, content)

    this.hideSpinner()
    this.setActiveTab(tab, content)
  }

  async loadTabContent(pageHandle, contentElement) {
    try {
      const response = await fetch(`/pages/${pageHandle}?view=size-chart`)
      if (response.ok) {
        const html = await response.text()
        const table = new DOMParser().parseFromString(html, 'text/html').querySelector('#MainContent .rte table')

        if (table) {
          contentElement.innerHTML = table.outerHTML
        } else {
          contentElement.innerHTML = '<p>No size chart available for this tab.</p>'
        }

        contentElement.dataset.loaded = 'true'
      } else {
        contentElement.innerHTML = '<p>Error loading size chart. Please try again later.</p>'
      }
    } catch (error) {
      console.error('Error fetching size chart:', error)
      contentElement.innerHTML = '<p>Error loading size chart. Please try again later.</p>'
    }
  }

  setActiveTab(tab, content) {
    this.tabs.forEach(t => t.classList.remove('is-active'))
    this.contents.forEach(c => c.classList.remove('is-active'))

    tab.classList.add('is-active')
    content.classList.add('is-active')
  }

  showSpinner() {
    if (this.spinner) {
      this.spinner.classList.add('is-active')
    }
  }

  hideSpinner() {
    console.log('hideSpinner:', this.spinner)
    if (this.spinner) {
      this.spinner.classList.remove('is-active')
    }
  }
}

customElements.define('size-chart', SizeChart)
